import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const CHARACTERS_AI_TWIN = [
  {
    title: "Chief marketing officer",
    subtitle: "Telecom company",
    items: [
      "Near real-time visibility and \nmeasurement of campaign \neffectiveness",
      "Understand consumers, \nemerging segment and \ntheir changing behavior to \ndefine or refine campaign in \nreal-time",
      "Visibility of my marketing \nspend on conversion and \nROI",
      "Strengthen brand \nperception index",
    ],
    image: "AI_TWIN/character_5.png",
    listMarginTop: "10px",
    next: {
      label: "AI TWIN DEMO",
      onClick: () => {
        setCurrentPage("AITWIN_313");
        setCurrentPage("AITWIN_305");
      },
      endIcon: "play",
    },
  },
];

export const DATA_CHARACTERS_AI_TWIN = {
  title: "Challenges solved",
  bgImage: "AI_TWIN/AI_Twin_04.png",
  characters: CHARACTERS_AI_TWIN,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_312"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
  actions: [
    {
      label: "AI TWIN DEMO",
      onClick: () => {
        setPreviousPage("AITWIN_313");
        setCurrentPage("AITWIN_305");
      },
      endIcon: "play",
    },
  ],
};
